module.exports = __webpack_public_path__ + "static/img/product-kegel.26e1050d.png";